import { useEffect, useState } from 'react';
import { FileManagedSystemDocument } from '../structures/response/FileManaged';
import { getAgentSystemDocuments } from '../api/agent';

export default function useAgentSystemDocuments(): {
  response: FileManagedSystemDocument[];
  fetchData: () => Promise<FileManagedSystemDocument[]>;
  getByType: (v: string) => FileManagedSystemDocument | undefined;
} {
  const [response, setResponse] = useState<FileManagedSystemDocument[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const r = await getAgentSystemDocuments();
      setResponse(r);
      return r;
    } catch (e) {
      console.log(e);
    }
    return [];
  }

  function getByType(type: string) {
    return Array.isArray(response)
      ? response.find((v) => v.viewUrl.includes(type))
      : undefined;
  }

  return { response, fetchData, getByType };
}
